<script lang="ts">import { browser } from "$app/environment";
import { cfgBrandTitle, cfgToThemeContentPath } from "@infinitro/config";
import { locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { applyStaticSeoPlaceholders, fetchLocaleRawWithEnFallback, renderSeoMarkdown } from "./fetch-markdown-seo";
export let showMoreButton = true;
export let withBackground = false;
export let noContainer = false;
export let section;
const BRAND_NAME = cfgBrandTitle();
let htmlContent = "";
let lastModified = "";
let relatedLinksHtml = "";
// Adopt the hidden build-time SEO block in place; absent on client navigation → fetch below.
const adopted = (() => {
	if (!browser) return false;
	const block = document.getElementById("seo-static-block");
	if (!block) return false;
	htmlContent = block.querySelector(".markdown-seo")?.innerHTML ?? "";
	relatedLinksHtml = block.querySelector(".seo-static__links")?.outerHTML ?? "";
	block.remove();
	return true;
})();
$: sec = section || "home";
$: loc = $locale;
$: if (!adopted) {
	if ($loggedIn === false && sec) {
		const localeUrl = cfgToThemeContentPath(`/seo/${sec}/${sec}.${loc}.md`);
		const enUrl = cfgToThemeContentPath(`/seo/${sec}/${sec}.en.md`);
		const capturedSec = sec;
		const capturedLoc = loc;
		fetchLocaleRawWithEnFallback(localeUrl, enUrl, { cacheBust: true }).then(({ raw, lastModified: lm }) => {
			if (capturedSec !== sec || capturedLoc !== $locale || $loggedIn !== false) return;
			const withPlaceholders = applyStaticSeoPlaceholders(raw, BRAND_NAME);
			htmlContent = renderSeoMarkdown(withPlaceholders);
			lastModified = lm;
		});
	} else {
		htmlContent = "";
		lastModified = "";
	}
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

<!-- `!== true`, not `=== false`: loggedIn resolves async; the block is already removed, so a
     crawler snapshotting before it resolves must still see the content. -->
{#if $loggedIn !== true}
	<CdnSeoMarkdownPanel
		{htmlContent}
		{lastModified}
		{showMoreButton}
		{withBackground}
		{noContainer}
	/>
	{#if relatedLinksHtml}
		<!-- eslint-disable-next-line svelte/no-at-html-tags -- build-generated links, not user input -->
		{@html relatedLinksHtml}
	{/if}
{/if}
